module.exports = __webpack_public_path__ + "img/app-store.157b1134.svg";